export default str => str
  .toLowerCase()
  .replace('_', ' ').split(' ')
  .map(item => item.replace(/^\w/, c => c.toUpperCase()))
  .join(' ');
